import { LinearGradient } from "expo-linear-gradient";
import { useTheme } from "tamagui";

export default function Gradient({ left }: { left: boolean }) {
  const theme = useTheme();
  return (
    <LinearGradient
      colors={[theme.backgroundFill.get(), "transparent"]}
      locations={[0, 0.05]}
      start={{ x: left ? 0 : 1, y: 0 }}
      end={{ x: left ? 0.1 : 0.9, y: 0 }}
      style={{
        pointerEvents: "none",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      }}
    />
  );
}
